setupAllVideoBlocks();

function setupAllVideoBlocks(){
    const videos = $('.player');

    videos.each(function(i, el){
        new Plyr(el);
    });
}